<div class="vrt-details product-detail-container">
  <app-tvshop-header [titleKey]="'eos-tv-shop-ii.title.vrt-net-gemist-header'"></app-tvshop-header>
  <div class="product-detail-content" #productdetailcontent>
    <app-product-detail-intro id="productDetailIntro" class="full"
                              [pack]="pack"
                              [superiorSubscribedPack]="superiorSubscribedPack"
                              [titleKey]="'eos-tv-shop-ii.title.vrt-net-gemist-details-intro'"
                              [descriptionKey]="'eos-tv-shop-ii.text.vrt-net-gemist-details-intro'"
                              (emitOrderProduct)="openOrderModal($event)"></app-product-detail-intro>
  </div>
  <app-ordering-modal-manager [order]="order"
                              #orderModal></app-ordering-modal-manager>
</div>

